<template>
  <div class="privacy-page">
    <section class="privacy-hero">
      <div class="app-container">
        <span class="eyebrow anim-fade-up">
          <i class="bi bi-shield-lock-fill text-flame"></i>
          KEBIJAKAN & PRIVASI
        </span>
        <h1 class="page-title anim-fade-up anim-delay-1">Kebijakan Privasi</h1>
        <p class="page-subtitle anim-fade-up anim-delay-2">
          Komitmen Arena Sport Digital dalam menjaga keamanan, kerahasiaan, dan privasi data Anda.
        </p>
      </div>
    </section>

    <section class="section">
      <div class="app-container">
        <div class="ui-card privacy-card" v-reveal>
          <div class="ui-card__body privacy-body">
            <h2 class="privacy-heading">1. Lingkup</h2>
            <p>
              Pemberitahuan Privasi ini berlaku untuk informasi, termasuk informasi pribadi, yang diperoleh oleh Arena Sport Digital tentang Anda selama menggunakan layanan pendaftaran, kejuaraan, dan manajemen pertandingan.
            </p>

            <h2 class="privacy-heading">2. Informasi Pribadi</h2>
            <p>
              Informasi pribadi yang kami kumpulkan digunakan semata-mata untuk operasional turnamen:
            </p>
            <ol class="privacy-list">
              <li>Kami menggunakan informasi yang kami peroleh untuk menyediakan produk dan jasa yang Anda minta, menginformasikan informasi penting kejuaraan, serta memproses verifikasi atlet dan kontingen.</li>
              <li>Kami dapat memvalidasi informasi yang Anda berikan dengan data resmi induk organisasi olahraga terkait demi memastikan kepatuhan kategori usia dan keabsahan atlet.</li>
              <li>Situs Web kami menggunakan teknologi penunjang seperti cookies sesi terenkripsi untuk mempertahankan keamanan akun dan preferensi tampilan (tema gelap/terang).</li>
            </ol>

            <h2 class="privacy-heading">3. Penggunaan & Pembagian Informasi</h2>
            <p>
              Kami tidak menjual, menyewakan, atau memperjualbelikan informasi pribadi pengunjung maupun peserta turnamen kepada pihak ketiga mana pun untuk tujuan pemasaran. Informasi peserta hanya dibagikan kepada panitia pelaksana turnamen terkait untuk penyusunan bagan, jadwal pertandingan, dan penerbitan piagam resmi.
            </p>

            <h2 class="privacy-heading">4. Perubahan Kebijakan Privasi</h2>
            <p>
              Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu demi mengikuti perkembangan hukum dan teknologi. Versi terkini akan selalu dapat diakses melalui tautan resmi di situs web Arena Sport Digital.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
};
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  padding-bottom: var(--space-16);
}

.privacy-hero {
  padding-block: var(--space-16) var(--space-12);
  background: var(--hero-bg);
  text-align: center;
  border-bottom: 1px solid var(--border-subtle);
}

.page-title {
  font-size: clamp(1.8rem, 5vw, 3rem);
  font-family: var(--font-display);
  font-weight: 800;
  margin-block: var(--space-3) var(--space-2);
  color: var(--text-primary);
}

.page-subtitle {
  max-width: 60ch;
  margin-inline: auto;
  color: var(--text-secondary);
  font-size: var(--text-base);
}

.privacy-card {
  max-width: 860px;
  margin-inline: auto;
}

.privacy-body {
  padding: var(--space-8);
}

.privacy-heading {
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--text-primary);
  margin-top: var(--space-6);
  margin-bottom: var(--space-2);
}

.privacy-heading:first-of-type {
  margin-top: 0;
}

.privacy-body p {
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: var(--space-4);
}

.privacy-list {
  color: var(--text-secondary);
  line-height: 1.7;
  padding-left: var(--space-5);
  margin-bottom: var(--space-4);
}

.privacy-list li {
  margin-bottom: var(--space-2);
}
</style>
  